import { render, staticRenderFns } from "./AboutCompany.vue?vue&type=template&id=4adea61a&scoped=true"
import script from "./AboutCompany.vue?vue&type=script&lang=js"
export * from "./AboutCompany.vue?vue&type=script&lang=js"
import style0 from "./AboutCompany.vue?vue&type=style&index=0&id=4adea61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adea61a",
  null
  
)

export default component.exports